import { GridColDef } from "@mui/x-data-grid";

export interface IAssignedUser {
  id: number;
  companyName: string;
  email: string;
  firstName: string;
  lastName: string;
  status: UserStatus;
  role: UserRole;
  pendingRequests: number;
  panelsOwned: number;
  created: string;
  updated: string;
}

export interface OrgUser extends IAssignedUser {
  organization: string;
}

export interface IAssignedUserColDef extends Omit<GridColDef, ""> {
  field: keyof IAssignedUser;
}

export interface IUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  jobTitle: string;
  companyName: string;
  address1?: string;
  address2?: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  status: UserStatus;
  role: UserRole;
  created: string;
  updated: string;
}

export enum UserRole {
  Admin = "Admin",
  Customer = "Customer",
  // CustomerSuccess = "Customer Success",
  // ProductManager = "Product Manager",
  SalesRep = "Sales Representative",
}

export enum UserRoleFilter {
  All,
  Customer,
}

export enum UserStatus {
  Pending,
  Verified,
  Decline,
  Inactive,
}
